import React from "react";
import { Link } from "react-router-dom";

function Pricing() {
  const plans = [
    {
      name: "Starter",
      price: "₹5000",
      desc: "Perfect for small businesses",
      features: [
        "2 Expert consultation support",
        "4 Graphics per week",
        "Basic branding setup",
        "No paid ads included",
        "No Leads",
        "Weekly performance report",
      ],
      highlight: false,
    },
    {
      name: "Growth",
      price: "₹10000",
      desc: "Most popular for business growth",
      features: [
        "Dedicated marketing team",
        "Daily 1 creative design",
        "4 Video posts weekly",
        "Social media handling",
        "Ads setup & running",
        "Targeted Leads",
        "Lead tracking system",
      ],
      highlight: true,
    },
    {
      name: "Premium",
      price: "₹15000",
      desc: "Full scale marketing solution",
      features: [
        "Complete brand strategy",
        "Daily creatives + reels",
        "Advanced video marketing",
        "Full social media management",
        "High-budget ad campaigns",
        "Guaranteed targeted Leads",
        "Audience targeting & scaling",
      ],
      highlight: false,
    },
  ];

  return (
    <section className="relative py-16 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">
      {/* SAME HERO GLOW EFFECT */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID BACKGROUND (same as hero) */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="myheading text-3xl md:text-5xl text-center">
            A Plan for Every{" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Business Need
            </span>
          </h2>
          <p className="myparagraph text-gray-500">
            Choose a plan that fits your growth stage and budget.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-2xl p-8 border transition duration-300 backdrop-blur-xl
              ${
                plan.highlight
                  ? "bg-primary/10 border-primary scale-105 shadow-xl"
                  : "bg-white dark:bg-white/5 border-gray-200 dark:border-white/10 hover:scale-105"
              }`}
            >
              {/* Glow top effect */}
              <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-40 h-40 bg-primary/20 blur-3xl rounded-full" />

              {plan.highlight && (
                <div className="absolute top-4 right-4 text-xs bg-primary text-white px-3 py-1 rounded-full">
                  Most Popular
                </div>
              )}

              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                {plan.name}
              </h3>

              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                {plan.desc}
              </p>

              <div className="mt-5 text-4xl font-bold text-gray-900 dark:text-white">
                {plan.price}
              </div>

              <p className="text-xs text-gray-500 mt-1">per month</p>

              {/* FEATURES */}
              <ul className="mt-6 space-y-3 text-sm text-gray-700 dark:text-gray-300">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex gap-2">
                    <span className="text-primary">✓</span>
                    {f}
                  </li>
                ))}
              </ul>

              {/* BUTTON */}
              <Link
                to="https://webxsecure.in/contact"
                className={`mt-8 inline-block text-center w-full py-3 rounded-xl font-medium transition
                ${
                  plan.highlight
                    ? "bg-primary text-white hover:bg-primary"
                    : "border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-white hover:bg-black/5 dark:hover:bg-white/10"
                }`}
              >
                Get Started
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pricing;
